// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 12.5C14.9624 12.5 12.5 14.9624 12.5 18C12.5 21.0376 14.9624 23.5 18 23.5C21.0376 23.5 23.5 21.0376 23.5 18C23.5 14.9624 21.0376 12.5 18 12.5ZM18.9999 20.4142L17 18.4141V15.752H19V17.5857L20.4142 19.0001L18.9999 20.4142Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.2547 14C11.4638 15.1338 11 16.5128 11 18C11 19.4872 11.4638 20.8662 12.2547 22H2V20C2 16.6863 4.68629 14 8 14H12.2547Z"}}]};

const UserTimeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-time-filled',
    ref,
    icon: element,
  },
));

UserTimeFilledIcon.displayName = 'UserTimeFilledIcon';

export default UserTimeFilledIcon;
